import React from "react";
export default function () {
    return (
        <svg width="200" height="200" viewBox="0 0 200 200">
            <g>
                <g>
                    <path d="M34.2,90.7c-2.7-4.7-10.7-5.4-17.9-1.6S5.4,99.8,8,104.5s10.7,5.4,18,1.6S36.9,95.4,34.2,90.7z" />
                    <rect x="33.1" y="23.2" width="1.9" height="71.8" />
                </g>
                <g>
                    <path d="M86.2,90.7c-2.7-4.7-10.7-5.4-17.9-1.6S57.4,99.8,60,104.5s10.7,5.4,18,1.6S88.9,95.4,86.2,90.7z" />
                    <rect x="85.1" y="23.2" width="1.9" height="71.8" />
                </g>
                <g>
                    <path d="M138.2,90.7c-2.7-4.7-10.7-5.4-17.9-1.6s-10.9,10.7-8.3,15.4s10.7,5.4,18,1.6S140.9,95.4,138.2,90.7z" />
                    <rect x="137.1" y="23.2" width="1.9" height="71.8" />
                </g>
                <rect x="33" y="23" width="106" height="10" />
                <path
                    d="M84.8,1.8l0.9,1.3c0.6,1.4,0,3.1-1.5,3.8C83.9,7,83.7,7,83.4,7.1h-1.3c-0.8-0.2-1.3-0.9-1.3-1.8c-0.2-1.5,0.7-3,2.2-3.5
                    c1.8-1.3,4-2,6.2-1.8c1.1,0.1,2.3,0.4,3.3,0.9c2,1,2.7,3.4,1.8,5.3c-0.1,0.1-0.1,0.3-0.2,0.4c-0.5,1.5-1.7,2.7-3.3,3.1l0,0
                    c1.8,0.6,3,2.5,2.6,4.4c-0.4,2.6-2.3,4.8-4.8,5.5c-2.5,0.8-5.2,0.8-7.7,0c-0.6,0-1.1-0.3-1.5-0.7c-1.3-0.9-1.7-2.6-0.8-4
                    c0.1-0.2,0.2-0.3,0.4-0.4c0.6-1.1,1.9-1.6,3.1-1.1c1,0.2,1.6,1.1,1.4,2c0,0.1-0.1,0.3-0.1,0.4l-1.5,2h-0.2c0.5,0.6,1.2,1,2,1.1h2
                    c1.1-0.2,2.1-1,2.6-2c0.5-1.4,0.6-2.9,0.4-4.4c-0.4-1.1-1.5-1.7-2.6-1.5h-1.5c-0.2,0-0.4-0.2-0.4-0.4c0-0.4-0.2-0.9,0.2-1.1h3.3
                    C89,9.3,90.2,8,90.3,6.4c0.2-0.9,0.3-1.9,0.2-2.9c0-1.3-0.9-2.2-2.4-2.4h-2.2L84.8,1.8z"
                />
            </g>
        </svg>
    );
}
